export default __webpack_public_path__ + "static/ct-30f708e983a46dd45618fec7fee7c426.jpg";